import Header from "@/components/Header";
import SiteFooter from "@/components/SiteFooter";
import PageHero from "@/components/PageHero";
import BookCTA from "@/components/BookCTA";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { AREAS } from "@/lib/areas";
import { usePageMeta } from "@/lib/seo";

export default function Areas() {
  usePageMeta(
    "Areas We Cover | House Clearance Peterborough & Nearby",
    "Waites Clearances covers Peterborough and surrounding areas including Oundle, Stamford, Huntingdon, Spalding, Whittlesey, March, Ely and Wisbech. Free house clearance quotes."
  );
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="page-areas">
      <Header />

      <PageHero
        eyebrow="Areas we cover"
        title="Peterborough and the wider region."
        description="We're based in Oundle, just outside Peterborough, and we cover the surrounding towns and villages across Cambridgeshire, Lincolnshire and Rutland. If you're near any of the places below, we can almost certainly help — and if you're not sure, ask and we'll tell you honestly."
      />

      <section className="py-20 sm:py-24" data-testid="areas-list">
        <div className="max-w-5xl mx-auto px-6 sm:px-10">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3">
            {AREAS.map(({ slug, name }) => (
              <Link
                key={slug}
                to={`/areas/${slug}`}
                data-testid={`area-${slug}`}
                className="group rounded-2xl border border-slate-200 bg-white px-4 sm:px-5 py-5 flex items-center gap-3 hover:border-[#FFB870] hover:shadow-md hover:-translate-y-0.5 transition-all"
              >
                <div className="h-10 w-10 rounded-xl bg-[#FFF3E6] flex items-center justify-center shrink-0">
                  <MapPin className="h-5 w-5 text-[#FF7F00]" />
                </div>
                <p className="font-display font-semibold text-slate-900 group-hover:text-[#FF7F00] transition-colors min-w-0">{name}</p>
                <ArrowRight className="ml-auto h-4 w-4 text-slate-300 group-hover:text-[#FF7F00] shrink-0 hidden sm:block transition-colors" />
              </Link>
            ))}
          </div>

          <div className="mt-12 rounded-3xl bg-white border border-slate-200 p-8 sm:p-10">
            <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
              Not on the list?
            </h2>
            <p className="mt-3 text-slate-600 leading-relaxed max-w-2xl">
              We regularly travel further afield from Peterborough for larger clearances and probate work. Start a
              booking with your postcode and we'll confirm the same day whether we can come out to
              you.
            </p>
          </div>
        </div>
      </section>

      <BookCTA
        title="Ready to book in Peterborough or nearby?"
        body="Enter your postcode in the wizard and we'll confirm availability by email — usually within the day."
      />

      <SiteFooter />
    </div>
  );
}
